import React, { useEffect, useState } from 'react';

import { collection, doc, getDoc, getDocs, query } from 'firebase/firestore';
import toast from 'react-hot-toast';
import { MdAddCircle } from 'react-icons/md';
import { useHistory } from 'react-router-dom';

import LoadingContainer from 'components/LoadingContainer';
import { Review } from 'interfaces/Review';
import Service from 'interfaces/Service';
import { db } from 'services/firebase';

import AddReviewModal from './AddReviewModal';
import EditReview from './EditReview';
import { Container, EditingHeader } from './styles';

const EditReviews: React.FC = () => {
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [serviceId, setServiceId] = useState<string>();
  const [service, setService] = useState<Service>();
  const [reviews, setReviews] = useState<Review[]>([]);

  useEffect(() => {
    const loadServiceData = async (): Promise<void> => {
      setLoading(true);

      const currentUrl = window.location.href.slice(0, -13);
      const id = currentUrl.substring(currentUrl.lastIndexOf('/') + 1);

      setServiceId(id);

      const serviceDoc = await getDoc(doc(db, 'services', id));
      const serviceData = serviceDoc.data() as Service;

      if (!serviceData) {
        toast.error(
          'Erro ao carregar informações do serviço. Recarregue a página e tente novamente',
          { duration: 2000 },
        );
        history.push('/');
        return;
      }

      setService(serviceData);

      const q = query(collection(db, `services/${id}/reviews`));
      const reviewsSnapshot = await getDocs(q);
      const reviewData = reviewsSnapshot.docs.map((document) => {
        return { id: document.id, ...document.data() };
      }) as Review[];

      setReviews(reviewData);
      setLoading(false);
    };

    loadServiceData();
  }, [history, serviceId]);

  return (
    <Container>
      {!service || loading ? (
        <LoadingContainer />
      ) : (
        <>
          <EditingHeader>
            <h1>
              {service?.name} -{' '}
              {service.categories.map((category, i) =>
                i === service.categories.length - 1
                  ? `${category.readableName}`
                  : `${category.readableName} / `,
              )}
            </h1>
            <div style={{ width: 30 }} />
            <MdAddCircle size={50} onClick={() => setIsModalOpen(true)} />
          </EditingHeader>
          {reviews.map((review, index) => (
            <EditReview
              key={`${serviceId}-${review.author.name}-${review.positive}`}
              index={index}
              review={review}
              setReviews={setReviews}
            />
          ))}
          <AddReviewModal
            serviceId={serviceId}
            isOpen={isModalOpen}
            setIsModalOpen={setIsModalOpen}
            setReviews={setReviews}
          />
        </>
      )}
    </Container>
  );
};

export default EditReviews;
